import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import App from './App';

const root = ReactDOM.createRoot( document.getElementById( 'root' ) );
root.render(
    <Router>
        <App />
        <ToastContainer position="bottom-right" />
        {process.env.REACT_APP_ENVIRONMENT && process.env.REACT_APP_ENVIRONMENT.toLowerCase() !== "production" && <div style={{ position: "fixed", bottom: 12, left: 12, zIndex: 2000, padding: "4px 12px", background: "#ff00ff", color: "#fff", fontWeight: 700, pointerEvents: "none" }}>{process.env.REACT_APP_ENVIRONMENT}</div>}
    </Router>
);

